import { useEffect, useRef } from 'react';
import { useAppDispatch } from '~/hooks/redux';
import config from "~/config";
import { goActive, goIdle } from '~/store/actions';

type TActivityStatusMonitorProps = {
  children?: any;
}

const ActivityStatusMonitor = ({ children }: TActivityStatusMonitorProps) => {

  const dispatch = useAppDispatch();
  const idleTimeout = useRef<NodeJS.Timeout | null>(null);
  const isIdle = useRef(false);

  useEffect(() => {
    setup();
    return () => cleanup();
  }, []);

  const setup = () => {
    document.addEventListener('mousemove', switchToActive, false);
    document.addEventListener('mousedown', switchToActive, false);
    document.addEventListener('keypress', switchToActive, false);
    document.addEventListener('DOMMouseScroll', switchToActive, false);
    document.addEventListener('mousewheel', switchToActive, false);
    document.addEventListener('touchmove', switchToActive, false);
    document.addEventListener('MSPointerMove', switchToActive, false);
    startTimer();
  };

  const cleanup = () => {
    document.removeEventListener('mousemove', switchToActive);
    document.removeEventListener('mousedown', switchToActive);
    document.removeEventListener('keypress', switchToActive);
    document.removeEventListener('DOMMouseScroll', switchToActive);
    document.removeEventListener('mousewheel', switchToActive);
    document.removeEventListener('touchmove', switchToActive);
    document.removeEventListener('MSPointerMove', switchToActive);
    if (idleTimeout.current) {
      clearTimeout(idleTimeout.current);
    }
  };

  const startTimer = () => {
    if (idleTimeout.current) {
      clearTimeout(idleTimeout.current);
    }
    idleTimeout.current = setTimeout(switchToIdle, config.USER_IDLE_DELAY * 1000);
  }

  const switchToActive = () => {
    if (idleTimeout.current) {
      clearTimeout(idleTimeout.current);
    }
    startTimer();
    if (isIdle.current) {
      isIdle.current = false;
      dispatch(goActive());
    }
  }

  const switchToIdle = () => {
    if (!isIdle.current) {
      isIdle.current = true;
      dispatch(goIdle());
    }
  }

  return <>
    {children}
  </>
}

export default ActivityStatusMonitor;